export const FEATURES = {
  enemyStances: true,
  statusSystem: true,
  cardTraits: true,
  eliteMutators: true,
  limitedSummons: true,
  bossPhaseScripts: true,
} as const;

